{
  "public-appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Book new appointment",
      "cancel": "Cancel appointment"
    }
  }
}
